








































import { Component, Vue } from "vue-property-decorator";
import UserForm from "@/views/Member/UserForm.vue";
import MyArticles from "@/views/Member/MyArticles.vue";
import Articles from "@/views/Reviewer/Articles.vue";
@Component({ components: { MyArticles, Articles, UserForm } })
export default class ProfileView extends Vue {
  get conference() {
    return this.$store.getters.getConferenceId;
  }

  get user() {
    return this.$store.getters.getUser;
  }

  menu: any = {
    myArticles: true,
    editProfile: false,
    reviewArticles: false,
  };

  displayEditProfile() {
    Object.keys(this.menu).forEach((key) => (this.menu[key] = false));
    this.menu.editProfile = true;
  }
  displayMyArticles() {
    Object.keys(this.menu).forEach((key) => (this.menu[key] = false));
    this.menu.myArticles = true;
  }
  displayReviewArticles() {
    Object.keys(this.menu).forEach((key) => (this.menu[key] = false));
    this.menu.reviewArticles = true;
  }

  logout() {
    const res = confirm("Are you sure you want to log out of your account ?");
    if (res) {
      this.$store.commit("setUser", {});
      this.$store.commit("setToken", null);
      this.$store.commit("authenticate", false);
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      this.$router.push("/login");
    }
  }
}
